import {
  BooleanInput,
  SimpleForm,
  SimpleFormProps,
  TextInput,
  required,
  SelectInput,
  FormDataConsumer
} from 'react-admin';
import { CustomEditor, UploadImageInput } from '../../components';

export enum PAGE_CATEGORIES {
  INTERNAL = 'INTERNAL',
  POPUP = 'POPUP'
}

export default function PagesForm(props: Partial<SimpleFormProps>) {
  return (
    <SimpleForm {...props} redirect="list">
      <SelectInput
        choices={[
          { id: PAGE_CATEGORIES.INTERNAL, name: 'Página interna' },
          { id: PAGE_CATEGORIES.POPUP, name: 'Popup' }
        ]}
        label="Categoria"
        source="category"
      />

      <TextInput
        fullWidth
        label="Título"
        source="title"
        validate={[required()]}
      />

    <FormDataConsumer>
      {
        ({ formData, ...rest}) => formData.category === PAGE_CATEGORIES.INTERNAL &&
          <>
            <TextInput
              fullWidth
              label="Subtítulo"
              source="subtitle"
              validate={[required()]}
            />

            <UploadImageInput
              fullWidth
              helperText="É possível enviar imagens no formato JPEG com dimensões recomendadas de 1920x384px."
              label="Imagem"
              upploadOptions={{
                maxSize: [1920, 384]
              }}
              mimeTypes={['image/jpeg']}
              source="image"
              validate={[required()]}
              cropOptions={{
                aspectRatio: 1920 / 384
              }}
            />
          </>
      }
    </FormDataConsumer>

      <CustomEditor
        fullWidth
        label="Texto"
        source="text"
        validate={[required()]}
      />

      <BooleanInput label="Ativo" source="active" defaultValue />
    </SimpleForm>
  );
}
